
import PropTypes from 'prop-types';
import React, { Component } from 'react';


export const FilterContext = React.createContext();

export class FilterProvider extends Component {

  ORDER_ASC = 'asc';
  ORDER_DESC = 'desc';

  static propTypes = {
    filterDefaults: PropTypes.object,
    storageKey: PropTypes.string
  };

  constructor(props) {
    super(props);

    this.state = {
      filter: {},
      storageKey: props.storageKey,
      order: {
        field: null,
        type: this.ORDER_ASC
      }
    };

    this.state.filter = this.getFilterDefaults();
    this.state.order = this.getOrderDefaults();

    this.setFilter = this.setFilter.bind(this);
  }

  setFilter = (values) => {
    if (values === undefined) {
      values = {};
    }

    this.setState({
      filter: values
    }, () => {
    });

    try {
      localStorage.setItem(`${this.state.storageKey}-filter`, JSON.stringify(values));
    }
    catch (e) {}
  };

  hasFilter = () => {
    return this.state.filter.length > 0;
  };

  setFilterValue = (key, value) => {
    let filter = this.state.filter;
    filter[key] = value;
    this.setFilter(filter);
  };

  getFilterDefaults = () => {
    const { filterDefaults } = this.props;
    let value = localStorage.getItem(`${this.state.storageKey}-filter`);
    let filterData = {};
    if (value) {
      try {
        filterData = JSON.parse(value);
      }
      catch (e) {}
    }

    for (const [key, value] of Object.entries(filterDefaults)) {
      if (filterData[key] === null || filterData[key] === undefined) {
        filterData[key] = value;
      }
    }
    return filterData;
  };

  getOrderDefaults = () => {
    var value = localStorage.getItem(`${this.state.storageKey}-order`);
    if (value) {
      try {
        return  JSON.parse(value);
      }
      catch (e) {}
    }
    return {};
  };

  setOrder = (name, type) => {
    let order = this.state.order;
    if (order.field === name) {
      if (order.type === this.ORDER_DESC) {
        order.field = null;
        order.type = this.ORDER_ASC;
      }
      else {
        order.type = type === this.ORDER_ASC ? this.ORDER_DESC : this.ORDER_ASC;
      }
    }
    else {
      order.field = name;
      order.type = this.ORDER_ASC;
    }

    this.setState({
      order: order
    });

    localStorage.setItem(`${this.state.storageKey}-order`, JSON.stringify(order));
  };

  getOrderField = (name) => {
    const order = this.state.order;
    if (order.field === name) {
      return order.type;
    }
    return null;
  };

  getOrderParams = () => {
    const order = this.state.order;
    if (order.field) {
      const type = order.type === this.ORDER_ASC ? '' : '-';
      return {
        o: `${type}${order.field}`
      }
    }
  };

  render() {
    return (
      <FilterContext.Provider value={{
        filter: this.state.filter,
        setFilter: this.setFilter,
        setFilterValue: this.setFilterValue,
        hasFilter: this.hasFilter,
        getOrderField: this.getOrderField,
        setOrder: this.setOrder,
        getOrderParams: this.getOrderParams
      }}>
        {this.props.children}
      </FilterContext.Provider>
    );
  }
}
